import { useState, useEffect, useCallback } from "react"
import { config } from "../../tools/config/realtimeProcessData"
import MarketRealTime from "../../components/MarketRealTime"
import getUrl from "../../tools/get-domain"
import * as calculates from "../../tools/market/realtime/calculates"


function MarketRealTimePage() {
    const [row, setRow] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)

    const fetchData = useCallback(async () => {
        setIsLoading(true)
        try {
            const response = await fetch(getUrl().REACT_APP_MARKET_SYMBOL_REALTIME)
            let data = await response.json()

            setIsLoading(false)

            let newData;
            newData = calculates.calculate_tval_5_22(data)
            newData = calculates.calculate_tval_5_60(data)
            newData = calculates.calculate_tval_22_60(data)
            newData = calculates.calculate_ao(data)
            newData = calculates.calculate_score(data)

            setRow(newData)
            
        } catch (err) {
            setIsLoading(false)
            setError('Something went wrong..., please try later.')
        }
    }, [])


    useEffect(() => {
        fetchData()
        const invterval = setInterval(() => fetchData(), 60000)
        return () => clearInterval(invterval)
    }, [fetchData])

    let content;

    if (isLoading) {
        content = 'Loading...'
    } else if (error) {
        content = error
    } else {
        content = <MarketRealTime config={config} row={row} />
    }

    return (
        <div>
            <div className="content flex-row-fluid" id="kt_content" dir="rtl">
                <div className="container-fluid mt-lg-0 mt-5">
                    <div className="row">
                        <div className="col-xl-12 d-block">
                            <div className=" h-100">
                                {content}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default MarketRealTimePage